<div class="container">
  <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [callbackFunction]="chartCallback"
    [style.display]="isPerformanceData ? 'block' : 'none'"
    style="height: 350px; width: 100%; display: block;"></highcharts-chart>
</div>
<app-loader *ngIf="loading"></app-loader>
<app-no-widget-data *ngIf="!loading && (!isPerformanceData || isUnderDateThreshold)"
  [svgSrc]="isUnderDateThreshold ? ('svg/no-widget-data-performance-date-threshold.svg' | assetVersion) : undefined">
</app-no-widget-data>